import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=b04dfe3e&scoped=true"
import script from "./companies.vue?vue&type=script&lang=js"
export * from "./companies.vue?vue&type=script&lang=js"
import style0 from "./companies.vue?vue&type=style&index=0&id=b04dfe3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04dfe3e",
  null
  
)

export default component.exports